import { Link } from 'react-router-dom'

interface NotFoundScreenProps {
  type: 'post' | 'product' | 'content'
  onBack?: () => void
  backTo?: string
  backLabel?: string
}

export function NotFoundScreen({
  type,
  onBack,
  backTo,
  backLabel
}: NotFoundScreenProps) {
  const getMessages = () => {
    switch (type) {
      case 'post':
        return {
          title: 'Post não encontrado',
          message: 'O post que você procura não existe ou foi removido.',
          backTo: backTo || '/blog',
          backLabel: backLabel || 'Voltar para o Blog'
        }
      case 'product':
        return {
          title: 'Produto não encontrado',
          message: 'O produto que você procura não existe ou está indisponível.',
          backTo: backTo || '/marketplace',
          backLabel: backLabel || 'Voltar para o Marketplace'
        }
      case 'content':
        return {
          title: 'Conteúdo não encontrado',
          message: 'O conteúdo que você procura não existe ou foi removido.',
          backTo: backTo || '/marketplace',
          backLabel: backLabel || 'Voltar para o Marketplace'
        }
    }
  }

  const { title, message, backTo: defaultBackTo, backLabel: defaultBackLabel } = getMessages()

  return (
    <div className="text-center py-12">
      <div className="text-brand-text-muted text-6xl mb-4">🔍</div>
      <h1 className="text-2xl font-bold text-brand-text mb-4">{title}</h1>
      <p className="text-brand-text-secondary mb-6">{message}</p>

      {onBack ? (
        <button
          onClick={onBack}
          className="btn-primary"
        >
          ← {defaultBackLabel}
        </button>
      ) : (
        <Link
          to={defaultBackTo}
          className="btn-primary inline-flex"
        >
          ← {defaultBackLabel}
        </Link>
      )}
    </div>
  )
}
